import React, { useState, useEffect, useCallback } from 'react';
import { withTranslation } from '../../../ChildrenContext.js';
import PropTypes from 'prop-types';
import CustomTooltip from '../../../Tooltip';
import PreviewOriginal from '../../../PreviewOriginal';
import ConstructorBanners from '../../../constructors/Banners/ConstructorBanners.container';
import BannerPreview from '../../../BannerPreview';
import DataComponentPromo from "../../../DataComponent/DataComponentPromo";
import { useTemplateConfig } from '../../../../context/TemplateConfigContext';

const columnTableData = {
    header: {
        0: {className: 'text-center', style: {width: 50}},
        4: {style: {width: 100}}
    },
    body: {
        0: {className: 'text-center'}
    }
};

const OfferPagePromoBanners = ({ 
    params, 
    location, 
    banners, 
    locales, 
    dimensions, 
    mimeTypes, 
    proportions, 
    headerNames, 
    loading, 
    totalPages, 
    getLocales, 
    getDimensions, 
    getMimeTypes, 
    getBanners, 
    saveBannerPresets, 
    t 
}) => {
    const { assets } = useTemplateConfig();
    const [state, setState] = useState({
        offerId: (params && params.id) || (location && location.params && location.params.id) || null,
        banners: banners || [],
        locales: locales || [],
        dimensions: dimensions || [],
        mimeTypes: mimeTypes || [],
        proportions: proportions || [],
        headerNames: headerNames || [],
        loading: loading || false,
        totalPages: totalPages || 0,
        modalIsVisible: false,
        constructorIsVisible: false,
        selectedBanner: {}
    });

    useEffect(() => {
        const params = { offerId: state.offerId };
        if (getLocales) getLocales(params);
        if (getDimensions) getDimensions(params);
        if (getMimeTypes) getMimeTypes(params);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setState(prevState => ({
            ...prevState,
            loading: loading,
            banners: banners || [],
            locales: locales || [],
            dimensions: dimensions || [],
            mimeTypes: mimeTypes || [],
            totalPages: totalPages || 0
        }));
    }, [loading, banners, locales, dimensions, mimeTypes, totalPages]);

    const showModalPreview = useCallback((data) => {
        setState(prevState => ({
            ...prevState,
            modalIsVisible: true,
            selectedBanner: data
        }));
    }, []);

    const showConstructor = useCallback((data) => {
        setState(prevState => ({
            ...prevState,
            constructorIsVisible: true,
            selectedBanner: data
        }));
    }, []);

    const closeModal = useCallback(() => {
        setState(prevState => ({
            ...prevState,
            modalIsVisible: false
        }));
    }, []);

    const closeConstructor = useCallback(() => {
        setState(prevState => ({
            ...prevState,
            constructorIsVisible: false
        }));
    }, []);

    const onClickShowModalPreview = useCallback((event) => {
        const index = event.target.closest('.control-item').getAttribute('data-index');
        showModalPreview(state.banners[index]);
    }, [state.banners, showModalPreview]);

    const onClickShowConstructor = useCallback((index) => {
        showConstructor(state.banners[index]);
    }, [state.banners, showConstructor]);

    const getBannersData = useCallback(() => {
        let banners = [];
        let staticNames = t?.offersPage?.offer || {};

        state.banners.map((banner, i) => {
            const mimeTypes = state.mimeTypes.find((item) => item.value.indexOf(banner.mime_type) !== -1);

            const dataPreview = {
                url: banner.url,
                originalWidth: banner.width,
                originalHeight: banner.height
            };

            let itemTitle = banner.title.slice(0,50);
            if (itemTitle.length < banner.title.length) {
                itemTitle += '...';
            }

            banners.push({
                id: banner.id,
                title: (
                    <CustomTooltip id={`banner-view-title-${i}`} tooltip={<PreviewOriginal {...dataPreview} />} placement={'right'} theme={'preview'}>
                        <div className="table-title" id={`banner-view-title-${i}`}>{itemTitle}</div>
                    </CustomTooltip>
                ),
                image: (
                    <div className="offer-item__table-img">
                        {banner.mime_type
                            ? (
                                <CustomTooltip id={`link-preview-${i}`} tooltip={<PreviewOriginal {...dataPreview} />} placement={'right'} theme={'preview'}>
                                    <a href={banner.url} id={`link-preview-${i}`} target="_blank">
                                        <img src={banner.url || assets.cap} alt="" />
                                    </a>
                                </CustomTooltip>
                            )
                            : (
                                <a href={banner.url} target="_blank">
                                    <img src={assets.cap} alt="" />
                                </a>
                            )
                        }
                    </div>
                ),
                url: banner.dimensions,
                action: (
                    <div className="offer-item__promo-banners-wrap">
                        <div className="offer-item__promo-banners-toolbar">
                            <button
                                className="btn btn-white generate-link"
                                onClick={() => { onClickShowConstructor(i); }}
                            >
                                {staticNames.generateBanner}
                            </button>
                            <a className="btn banner-download" href={banner.url} download target="_blank">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M19.6875 10C19.6921 11.5563 19.1869 13.0712 18.2492 14.3133C18.098 14.5069 17.8769 14.6335 17.6333 14.6657C17.3897 14.698 17.1433 14.6333 16.9469 14.4857C16.7505 14.3381 16.6199 14.1192 16.5833 13.8763C16.5466 13.6334 16.6067 13.3858 16.7508 13.1867C17.2556 12.5132 17.5932 11.7294 17.7358 10.8999C17.8783 10.0703 17.8217 9.21876 17.5706 8.41538C17.3195 7.612 16.8811 6.87978 16.2915 6.27906C15.7019 5.67834 14.978 5.22631 14.1795 4.96022C13.3809 4.69412 12.5306 4.62158 11.6985 4.74857C10.8664 4.87556 10.0764 5.19844 9.39362 5.69062C8.7108 6.18279 8.1547 6.83016 7.77114 7.5794C7.38758 8.32864 7.18754 9.15829 7.18749 10C7.18749 10.2486 7.08872 10.4871 6.91291 10.6629C6.73709 10.8387 6.49864 10.9375 6.24999 10.9375C6.00135 10.9375 5.7629 10.8387 5.58708 10.6629C5.41127 10.4871 5.31249 10.2486 5.31249 10C5.31204 9.47447 5.36942 8.95048 5.48359 8.4375C4.57191 8.45625 3.70501 8.8364 3.07362 9.49432C2.44222 10.1522 2.09804 11.034 2.11679 11.9457C2.13554 12.8574 2.51569 13.7243 3.17361 14.3557C3.83152 14.9871 4.71331 15.3313 5.62499 15.3125H7.49999C7.74864 15.3125 7.98709 15.4113 8.16291 15.5871C8.33872 15.7629 8.4375 16.0014 8.4375 16.25C8.4375 16.4986 8.33872 16.7371 8.16291 16.9129C7.98709 17.0887 7.74864 17.1875 7.49999 17.1875H5.62499C4.90374 17.1884 4.18986 17.0424 3.52686 16.7584C2.86386 16.4745 2.26563 16.0585 1.76862 15.5358C1.27161 15.0131 0.88624 14.3947 0.635991 13.7183C0.385741 13.0418 0.275856 12.3215 0.313031 11.6012C0.350206 10.8809 0.533663 10.1757 0.852222 9.52862C1.17078 8.88153 1.61777 8.30608 2.16594 7.83734C2.71412 7.36861 3.352 7.01641 4.04071 6.8022C4.72942 6.588 5.45454 6.51628 6.17187 6.59141C6.93076 5.1823 8.13825 4.0668 9.60294 3.4217C11.0676 2.7766 12.7057 2.63883 14.2576 3.0302C15.8095 3.42158 17.1864 4.31972 18.1699 5.58227C19.1535 6.84482 19.6876 8.39954 19.6875 10ZM13.7117 13.0867L12.8125 13.9844V10C12.8125 9.75136 12.7137 9.51291 12.5379 9.33709C12.3621 9.16127 12.1236 9.0625 11.875 9.0625C11.6264 9.0625 11.3879 9.16127 11.2121 9.33709C11.0363 9.51291 10.9375 9.75136 10.9375 10V13.9844L10.0383 13.0844C9.95107 12.9972 9.84754 12.928 9.7336 12.8808C9.61966 12.8336 9.49754 12.8093 9.37421 12.8093C9.25089 12.8093 9.12877 12.8336 9.01483 12.8808C8.90089 12.928 8.79736 12.9972 8.71015 13.0844C8.62294 13.1716 8.55377 13.2751 8.50657 13.3891C8.45938 13.503 8.43509 13.6251 8.43509 13.7484C8.43509 13.8718 8.45938 13.9939 8.50657 14.1078C8.55377 14.2218 8.62294 14.3253 8.71015 14.4125L11.2102 16.9125C11.2972 16.9999 11.4007 17.0693 11.5147 17.1166C11.6287 17.1639 11.7508 17.1882 11.8742 17.1882C11.9976 17.1882 12.1198 17.1639 12.2337 17.1166C12.3477 17.0693 12.4512 16.9999 12.5383 16.9125L15.0383 14.4125C15.2144 14.2364 15.3133 13.9975 15.3133 13.7484C15.3133 13.4994 15.2144 13.2605 15.0383 13.0844C14.8622 12.9083 14.6233 12.8093 14.3742 12.8093C14.1251 12.8093 13.8863 12.9083 13.7102 13.0844L13.7117 13.0867Z" fill="var(--offer-download-icon-color, #000055)"/>
                                </svg>
                            </a>
                        </div>
                    </div>
                )
            });
        });

        return banners;
    }, [state.banners, state.mimeTypes, t, onClickShowConstructor]);

    const onDataTableAction = useCallback((state, actionType) => {
        if (getBanners) {
            getBanners({
                ...state,
                offer_ids: state.offerId
            }, actionType);
        }
    }, [state.offerId, getBanners]);

    const staticNames = t?.dataTable || {};

    return (
        <React.Fragment>
            <DataComponentPromo
                onAction={onDataTableAction}
                totalPages={state.totalPages}
                headerNames={state.headerNames}
                data={getBannersData()}
                loading={state.loading}
                withoutDatepicker={true}
                textInput={true}
                alignPagination={true}
                columnData={columnTableData}
                hidden={true}
            />
            <BannerPreview
                isVisible={state.modalIsVisible}
                url={state.selectedBanner.url}
                title={state.selectedBanner.title}
                width={state.selectedBanner.width}
                height={state.selectedBanner.height}
                onClose={closeModal}
            />
            <ConstructorBanners
                visible={state.constructorIsVisible}
                banner={state.selectedBanner}
                onClose={closeConstructor}
                onSave={saveBannerPresets}
            />
        </React.Fragment>
    );
};

OfferPagePromoBanners.propTypes = {
    params: PropTypes.object,
    location: PropTypes.object,
    banners: PropTypes.array,
    locales: PropTypes.array,
    dimensions: PropTypes.array,
    mimeTypes: PropTypes.array,
    proportions: PropTypes.array,
    headerNames: PropTypes.array,
    loading: PropTypes.bool,
    totalPages: PropTypes.number,
    getLocales: PropTypes.func,
    getDimensions: PropTypes.func,
    getMimeTypes: PropTypes.func,
    getBanners: PropTypes.func,
    saveBannerPresets: PropTypes.func,
    t: PropTypes.object
};

OfferPagePromoBanners.defaultProps = {
    banners: [],
    locales: [],
    dimensions: [],
    mimeTypes: [],
    proportions: [],
    headerNames: [],
    loading: false,
    totalPages: 0,
    getLocales: () => {},
    getDimensions: () => {},
    getMimeTypes: () => {},
    getBanners: () => {},
    saveBannerPresets: () => {},
    t: {}
};

export default withTranslation(OfferPagePromoBanners);
